import React from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import Layout from '../Layout'
import SEO from '../components/SEO'
import ProductCarousel from '../components/ProductCarousel'
import SimpleHeroBanner from '../components/SimpleHeroBanner/SimpleHeroBanner'
import PartnerBody from '../components/PartnerBody/PartnerBody'
import StaticSignUpBanner from '../components/StaticSignUpBanner'

const PartnerTemplate = ({ location, data, pageContext }) => {
  const {
    brandName,
    slug,
    body,
    logo,
  } = data.contentfulBrand

  const products = data.allContentfulProduct.edges.map(edge => ({
    ...edge.node,
    ctaLabel: '詳しく見る',
    ctaLink: edge.node.viewDetailsLink,
    productSpecification: edge.node.metaDescription,
  }))

  return (
    <Layout lighttheme>
      <SEO pagePath={slug} postNode={data.contentfulBrand} postSEO />

      <main className="main-content">
        <h1 className="sr-only">{brandName}</h1>
        <SimpleHeroBanner title={brandName} />
        <PartnerBody title={brandName} logo={logo ? logo.fixed.src : null}>
          <div dangerouslySetInnerHTML={{
            __html: body.childMarkdownRemark.html,
          }}
          />
        </PartnerBody>
        <ProductCarousel products={products} />
        <StaticSignUpBanner />
      </main>
    </Layout>
  )
}

export const query = graphql`
  query($slug: String!) {
    contentfulBrand(slug: { eq: $slug }) {
      id
      brandName
      slug
      metaDescription {
        internal {
          content
        }
      }
      logo {
        fixed(width: 1600) {
          width
          height
          src
          srcSet
        }
      }
      body {
        childMarkdownRemark {
          html
        }
      }
    }
    allContentfulProduct(
      filter: {
        brand: {
          slug: {
            eq: $slug
          }
        }
      }
    ) {
      edges {
        node {
          id
          title
          transliteratedName
          productType
          productCategoryGenre {
            ...GenreFragment
            ...ProductCategoryFragment
          }
          brand {
            brandName
            brandUrl
          }
          image {
            altText
            imageFile {
              file {
                url
              }
            }
          }
          viewDetailsLink
          metaDescription {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
  }
`

PartnerTemplate.propTypes = {
  data: PropTypes.shape({
    contentfulPost: PropTypes.shape({
      featuredImage: PropTypes.object,
      publishDate: PropTypes.string,
      tags: PropTypes.array,
      categories: PropTypes.shape({
        title: PropTypes.string.isRequired,
      }).isRequired,
      title: PropTypes.string,
      slug: PropTypes.string,
      body: PropTypes.shape({
        childMarkdownRemark: PropTypes.shape({
          html: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,

  pageContext: PropTypes.shape({
    prev: PropTypes.object,
    next: PropTypes.object,
  }).isRequired,

  location: PropTypes.shape({
    href: PropTypes.string,
  }).isRequired,
}

export default PartnerTemplate
